import {
    Button, Form, Input, Modal, Space, message, Typography, Empty, List, Alert
} from "antd";
import { useEffect, useState } from "react";
import { searchCourseByCouponCode } from './../_services/coupon.service';
import CollectionMiniCard from './CollectionMiniCard';

const { Search } = Input;
const { Paragraph, Text } = Typography;

const CourseFindClassCode = () => {

    const [form] = Form.useForm();
    const [loading, setLoading] = useState(false);
    const [modalVisible, serModalVisible] = useState(false);
    const [couponCodeWarning, serCouponCodeWarning] = useState(null);
    const [courses, setCourses] = useState([])

    const handleOnFinish = async (values) => {
        reset();
        setLoading(true);
        try {
            const data = await searchCourseByCouponCode(values.couponCode);
            if (!data.courses.length) {
                message.error("No courses found this coupon code.");
                setLoading(false);
                return;
            }

            if (data.warning) {
                serCouponCodeWarning(data.warning)
            }

            setCourses(data.courses)
            setLoading(false);
        } catch (error) {
            if (parseInt(error.message) === 401) {
                message.error("User session expired, please login again.");
                setLoading(false);
                return;
            }
            setLoading(false);
            message.error(error.message || "Something went wrong when search course!");
        }
    };

    const handleOnSearch = () => {
        form.submit();
    };

    const handleOnCancel = () => {
        serModalVisible(false);
        form.resetFields();
    };

    // Class Code Search Button
    const ClassCodeSearchButton = () => {
        return <Button type="primary" onClick={() => serModalVisible(true)}>
            Have a class code?
        </Button>
    }

    const CourseSearchResult = () => {
        return (
            <>
                {courses.length > 0 ? (
                    <List
                        grid={{
                            gutter: [8, 8],
                            xs: 1,
                            sm: 2,
                            md: 2,
                            lg: 2,
                            xl: 2,
                            xxl: 2
                        }}
                        pagination={{
                            hideOnSinglePage: true,
                            pageSize: 2
                        }}
                        dataSource={courses}
                        renderItem={(course) => (
                            <List.Item key={course.id}>
                                <CollectionMiniCard collection={course} />
                            </List.Item>
                        )}
                    />
                ) : (
                    <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} />
                )}
            </>
        )
    }

    const ModalContent = () => {
        return (
            <Paragraph>
                <Space direction="vertical" style={{ width: "100%" }}>
                    <Text>
                        Search Course with a class code:
                    </Text>
                    <Form form={form} onFinish={handleOnFinish}>
                        <Form.Item
                            name="couponCode"
                            rules={[
                                {
                                    required: true,
                                    message: "Please input a coupon code!"
                                }
                            ]}>
                            <Search
                                style={{ width: "100%" }}
                                placeholder="Class Code"
                                allowClear
                                enterButton="Submit"
                                loading={loading}
                                onSearch={handleOnSearch}
                            />
                        </Form.Item>
                    </Form>
                    {couponCodeWarning && <>
                        <Alert
                            message={couponCodeWarning}
                            banner
                            closable
                        />
                    </>}
                    <CourseSearchResult />
                </Space>
            </Paragraph>
        );
    };

    const reset = () => {
        setCourses([]);
        serCouponCodeWarning(null);
        setLoading(false);
    }

    useEffect(() => {
        if (!modalVisible) {
            reset()
        }
    }, [modalVisible])


    return (
        <>
            <ClassCodeSearchButton />
            <Modal
                visible={modalVisible}
                onCancel={handleOnCancel}
                footer={null}
                width={700}>
                <div className="modal-body">
                    <ModalContent />
                </div>
            </Modal>
        </>
    );

}

export default CourseFindClassCode